import { useEffect, useState } from 'react';
import { ArrowUpRight, Menu, X } from 'lucide-react';
import Logo from './Logo';
import { company, navLinks } from '../data/content';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState('home');

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 30);
      let current = 'home';
      navLinks.forEach(({ id }) => {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 140) current = id;
      });
      setActive(current);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className="fixed inset-x-0 top-0 z-50 px-3 pt-3 sm:px-6 sm:pt-4">
      <nav
        className={`mx-auto flex max-w-6xl items-center justify-between rounded-full py-2 pl-4 pr-2 transition-all duration-500 ${
          scrolled || open
            ? 'bg-ink/90 shadow-2xl shadow-black/30 ring-1 ring-white/10 backdrop-blur-xl'
            : 'bg-transparent'
        }`}
      >
        <a href="#home" onClick={() => setOpen(false)} aria-label="Agnisafe Engineering home">
          <Logo light compact />
        </a>

        <ul className="hidden items-center gap-1 rounded-full bg-white/5 p-1 ring-1 ring-white/10 lg:flex">
          {navLinks.map(({ id, label }) => (
            <li key={id}>
              <a
                href={`#${id}`}
                className={`block rounded-full px-4 py-2 text-sm font-medium transition ${
                  active === id ? 'bg-white text-ink' : 'text-gray-300 hover:text-white'
                }`}
              >
                {label}
              </a>
            </li>
          ))}
        </ul>

        <a href="#contact" className="btn-primary hidden !py-2.5 lg:inline-flex">
          Get a Quote <ArrowUpRight className="h-4 w-4" />
        </a>

        <button
          type="button"
          className="rounded-full bg-white/10 p-2.5 text-white lg:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          aria-expanded={open}
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </nav>

      {open && (
        <div className="mx-auto mt-2 max-w-6xl overflow-hidden rounded-3xl bg-ink/95 p-3 ring-1 ring-white/10 backdrop-blur-xl lg:hidden">
          <ul className="flex flex-col">
            {navLinks.map(({ id, label }, i) => (
              <li key={id}>
                <a
                  href={`#${id}`}
                  onClick={() => setOpen(false)}
                  className={`flex items-center justify-between rounded-2xl px-4 py-3.5 font-display text-lg ${
                    active === id ? 'bg-brand-600 text-white' : 'text-gray-200 hover:bg-white/5'
                  }`}
                >
                  {label}
                  <span className="text-xs text-white/40">0{i + 1}</span>
                </a>
              </li>
            ))}
            <li className="pt-2">
              <a href={`tel:${company.phoneRaw}`} className="btn w-full bg-white text-ink">
                Call {company.phone}
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
